import { FunctionComponent, useCallback, useContext, useRef, useState, useEffect, ChangeEvent } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, MenuItem, Select, SelectChangeEvent, styled, Switch, Tooltip, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faCogs, faObjectGroup, faSquareList, faTableList } from '@fortawesome/pro-duotone-svg-icons';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { ISourceDataFormSettings } from '@/utilities/forms/SourceDataFormProcessor';
import { ISourceDataReviewCounts } from '@/hooks/form/useSourceDataReviewCounts';
import { FormSubmitButton } from '@ngt/forms';

const SettingsDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(0),
    },

    '& .MuiDialogActions-root': {
      padding: theme.spacing(2),
    },
}));

const Field = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2)
}));

interface ISourceDataFormConfirmationProps {
    counts?: ISourceDataReviewCounts;
    setCounts: (update :((current?: ISourceDataReviewCounts) => ISourceDataReviewCounts | undefined)) => void;
}

const SourceDataFormConfirmation: FunctionComponent<ISourceDataFormConfirmationProps> = ({
    counts,
    setCounts
}) => {

    return (
        <SettingsDialog
            disablePortal
            open={!!counts}
            onClose={() => setCounts(() => undefined)}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle sx={{ m: 0, p: 2, alignItems: 'center' }}>
                Incomplete Patient Review
                <IconButton
                    aria-label="close"
                    onClick={() => setCounts(() => undefined)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <FontAwesomeIcon icon={faTimes} fixedWidth />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Typography sx={{m: 2}}>
                    The source data review has not been completed.
                </Typography>
                <Typography sx={{m: 2}}>
                    Are you sure you wish to finish the review for this patient?
                </Typography>
            </DialogContent>
            <DialogActions>
                <FormSubmitButton variant='contained'>
                    Ok
                </FormSubmitButton>
                <Button onClick={() => setCounts(() => undefined)}>
                    Cancel
                </Button>
            </DialogActions>
        </SettingsDialog>
    );
}

export default SourceDataFormConfirmation;